import { Sparkles } from 'lucide-react';
import { formatXml } from '../../utils/xml';
import { useToast } from '../../contexts/ToastContext';

export default function FormatXmlButton({
  value,
  onChange,
  label = 'Format XML',
}: {
  value: string;
  onChange: (next: string) => void;
  label?: string;
}) {
  const { toast } = useToast();

  const onClick = () => {
    if (!value.trim()) {
      toast('Nothing to format', 'info');
      return;
    }
    // DOMParser is the same engine the transformation runs on, so a document
    // that formats here is one the processor will also accept.
    const doc = new DOMParser().parseFromString(value, 'application/xml');
    const parseError = doc.getElementsByTagName('parsererror')[0];
    if (parseError) {
      toast('Cannot format: the XML is not well formed', 'error');
      return;
    }
    const formatted = formatXml(value);
    if (formatted === value.trim()) {
      toast('Already formatted', 'info');
      return;
    }
    onChange(formatted);
    toast('Formatted', 'success');
  };

  return (
    <button
      onClick={onClick}
      className="icon-btn"
      title={label}
      aria-label={label}
    >
      <Sparkles className="w-4 h-4" />
    </button>
  );
}
